export default "__VITE_ASSET__bc96b039__"